var map = {
	"./da-DK.json": [
		91240,
		5639
	],
	"./de-DE.json": [
		10159,
		159
	],
	"./en-GB.json": [
		67344,
		7344
	],
	"./en-US.json": [
		53746,
		3746
	],
	"./es-ES.json": [
		96485,
		6485
	],
	"./es-MX.json": [
		18330,
		8330
	],
	"./fr-FR.json": [
		76737,
		6737
	],
	"./it-IT.json": [
		19869,
		9869
	],
	"./nb-NO.json": [
		24861,
		4861
	],
	"./nl-NL.json": [
		50040,
		2418
	],
	"./pl-PL.json": [
		63075,
		3075
	],
	"./pt-BR.json": [
		4845,
		4845
	],
	"./pt-PT.json": [
		49581,
		9581
	],
	"./sv-SE.json": [
		21043,
		1043
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 71962;
module.exports = webpackAsyncContext;